import {catalogApi, getBrowserCountryCode, storefrontApi} from './Api';

const sessions = new Map();

// Share each stage across header, footer and home, including failed stages.
// Later stages may continue after a failure rather than repeatedly retrying it.
function sessionFor(country) {
    const selectedCountry = country || localStorage.getItem('country_id') || getBrowserCountryCode();
    const key = String(selectedCountry).toUpperCase();
    if (!sessions.has(key)) sessions.set(key, {country:selectedCountry});
    return sessions.get(key);
}

function announcement(session) {
    if (!session.announcement) {
        session.announcement = storefrontApi.getAnnouncementBar(session.country).then(response => {
            const resolvedId = response?.data?.data?.country_id || response?.data?.offers?.[0]?.country_id;
            if (resolvedId && !sessions.has(String(resolvedId))) sessions.set(String(resolvedId), session);
            return response;
        });
    }
    return session.announcement;
}

function menu(session) {
    if (!session.menu) {
        session.menu = announcement(session).catch(() => null).then(() => catalogApi.getMenu());
    }
    return session.menu;
}

export function loadStartupAnnouncement(country) {
    return announcement(sessionFor(country));
}

export function loadStartupMenu() {
    return menu(sessionFor());
}

export function loadStartupHome() {
    const session = sessionFor();
    if (!session.home) {
        session.home = menu(session).catch(() => null).then(() => storefrontApi.getHome());
    }
    return session.home;
}

export function resetStorefrontStartup() {
    sessions.clear();
}
